import Md5 from 'blueimp-md5';
import rp from 'request-promise';
import urlencode from 'urlencode';
import config from './config';
import api from './api';
import { message } from 'antd';

const app = {
  /**
   * 储存值
   * @param key
   * @param value
   */
  setData(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value + '');
  },

  /**
   * 获取储存的值
   * @param key
   * @param defaultData
   * @returns {*}
   */
  getData(key, defaultData) {
    const val = localStorage.getItem(key);
    try {
      if (val) {
        if (key === 'account') return val;
        if (key === 'rights') {
          return parseInt(val);
        }
        let obj = JSON.parse(val);
        if (typeof obj === 'object' && obj) {
          return obj;
        } else {
          return val;
        }
      } else {
        return defaultData;
      }
    } catch (e) {
      // console.error(e);
      return val;
    }
  },

  /**
   * 获取储存的值
   * @param keys
   * @returns {*}
   */
  getDatas(...keys) {
    let obj = {};
    for (let i = 0; i < keys.length; i++) {
      if (keys[i]) {
        obj[keys[i]] = app.getData(keys[i]);
      }
    }
    return obj;
  },

  /**
   * 删除储存的值
   * @param key
   */
  removeData(key) {
    localStorage.removeItem(key);
  },

  /**
   * 储存token
   * @param val
   */
  setToken(val) {
    app.setData('token', val);
  },

  /**
   * 储存token（用于首页、搜索页、个人页面判断是否为假）
   * @param val
   */
  setTokeni(val) {
    app.setData('version', val);
  },

  /**
   * 获取token
   * @param val
   */
  getToken() {
    return app.getData('token');
  },

  /**
   * 获取tokeni
   * @param val
   */
  getStoreTokeni() {
    return app.getData('version');
  },

  /**
   * 删除token
   */
  removeToken() {
    app.removeData('token');
  },

  /**
   * post请求
   * @param url
   * @param data
   * @returns {AxiosPromise<any>}
   */
  post(url, data) {
    return app.request('POST', url, data);
  },

  /**
   * get请求
   * @param url
   * @param data
   * @returns {AxiosPromise<any>}
   */
  get(url, data = {}) {
    return new Promise((resolve, reject) => {
      const options = {
        method: 'GET',
        uri: url,
        qs: data,
        encoding: 'UTF-8',
        baseUrl: config.serverUrl,
        // json: true
      };
      rp(options).then((res) => {
        res = JSON.parse(res);
        // const yc = setTimeout(() => {
        if (res.flag === 400) {
          message.config({ top: '40%', duration: 1.5 });
          message.warn('请重新登录~', () => {
            app.clearInfo2();
            window.location.href = '/login';
          });
          reject();
        } else {
          resolve(res);
        }
        //     clearTimeout(yc);
        // }, 2000);
      }).catch((err) => {
        if (config.debug) console.error(err);
        app.alert('网络服务忙~', 'warn');
        reject();
      });
    });
  },

  /**
   * 请求
   * @param method
   * @param uri
   * @param form
   * @returns {*}
   */
  request(method, uri, form) {
    return new Promise((resolve, reject) => {
      if (!form) form = {};
      const token = app.getToken();
      if (token) {
        form.token = token;
      }
      const options = {
        method,
        uri,
        form,
        encoding: 'UTF-8',
        baseUrl: config.serverUrl,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        // json: true
      };
      rp(options).then((res) => {
        res = JSON.parse(res);
        // const yc = setTimeout(() => {
        if (res.flag === 400) {
          message.config({ top: '40%', duration: 1.5 });
          message.warn('请重新登录~', () => {
            app.clearInfo2();
            window.location.href = '/login';
          });
          reject();
        } else {
          resolve(res);
        }
        //     clearTimeout(yc);
        // }, 2000);
      }).catch((err) => {
        if (config.debug) console.error(err);
        app.alert('网络服务忙~', 'warn');
        reject();
      });
    });
  },

  /**
   * 判断字符串是否JSON
   * @param str
   * @returns {boolean}
   */
  isJson(str) {
    try {
      const obj = JSON.parse(str);
      if (typeof obj === 'object' && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  },

  /**
   * md5加密
   * @param val
   * @returns {*}
   */
  md5(val) {
    return Md5(val);
  },

  /**
   * 返回指定位数的随机数
   * @param n
   * @returns {*}
   */
  getRandom(n) {
    let random = Math.random() * Math.pow(10, n);
    random += '';
    return random[0];
  },

  /**
   * 弹框
   * @param msg
   * @param type
   * @param times
   */
  alert(msg, type = 'info', top = '35%', times = 1.5) {
    message.config({
      top: top,
      duration: 3
    });
    message[type](msg, times);
  },

  /**
   * 销毁弹框
   */
  alertDestroy() {
    message.destroy();
  },

  clearInfo2() {
    app.removeToken();
    app.removeData('rights');
    app.removeData('hasmallrole');
    app.removeData('team');
    app.removeData('indexno');
    app.removeData('multeamright');
    app.removeData('account');
    app.removeData('vname');
    app.removeData('team_id');
    app.removeData('teampositionname');
    app.removeData('teamname');
    app.removeData('idno');
    app.removeData('nickname');
    app.removeData('passport');
    app.removeData('bloodtype');
    app.removeData('drughis');
    app.removeData('emecontact');
    app.removeData('emecontactphone');
    app.removeData('message_audit');
    app.removeData('nationwide_rights');
    app.removeData('InitialInfo');

  },

  /**
   * 清除信息
   */
  clearInfo(history) {
    const data = {
      indexno: app.getData('indexno'),
      account: app.getData('account')
    };
    message.loading('正在退出登录...', 0);
    app.post(api.Logout, data).then(({ flag }) => {
      message.destroy();
      if (flag === 1) {
        app.clearInfo2();
        app.alert('退出成功~', 'success');
        history.push('/login');
        // history.replace('/login');
        // window.location.href='/login';
      } else {
        app.alert('退出失败~', 'error');

      }
    }).catch((err) => {
      message.destroy();
      app.alert('退出失败~', 'error');
      console.log(err);
    });
  },

  /**
   * 检查登录
   * @returns {boolean}
   */
  checkLogin() {
    const token = app.getToken();
    if (token) {
      return false;
    }
    return true;
  },

  /**
   * 图片转Base64
   * @param img
   * @param callback
   */
  getBase64(img) {
    // return new Promise((resolve)=>{
    //     const image = new Image();
    //     image.src = img;
    //     image.onload = ()=> {
    //         const canvas = document.createElement("canvas");
    //         canvas.width = image.width;
    //         canvas.height = image.height;
    //         const ctx = canvas.getContext("2d");
    //         ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    //         const dataURL = canvas.toDataURL();
    //         resolve(dataURL);
    //     }
    // })
  },

  /**
   * 指定位置替换成字符
   * @param str
   * @param newstr
   * @param start
   * @param end
   */
  replaceIndexStr(str, char, start, end) {
    const length = str.length;
    if (!end || end >= length) end = length - 1;
    const strArr = str.split('');
    const startStr = strArr.map((s, index) => {
      if (index <= start) {
        return s;
      }
      return '';
    }).join('');
    const endStr = strArr.map((s, index) => {
      if (index >= end) {
        return s;
      }
      return '';
    }).join('');
    const reStr = [];
    const reLen = end - start;
    for (let i = 0; i < reLen; i++) {
      reStr.push(char);
    }
    return startStr + reStr.join('') + endStr;

  },

  /**
   * url中文转gb2312
   * @param url
   * @returns {*}
   */
  urlEncode(url) {
    return url || '';
    // if (!url) return '';
    // const new_url = url.replace(/([^\u0000-\u00FF])/g, function (str) {
    //   return urlencode(str, 'GB2312');
    // });
    // return new_url;
  },

  /**
   * 图片上传前
   * @param file
   * @returns {boolean}
   */
  beforeUpload(file) {
    return new Promise((resolve, reject) => {
      const isJPG = ['image/jpeg', 'image/png'].indexOf(file.type) > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        message.error('您只能上传JPG、PNG 文件！');
        reject(file);
      } else if (!isLt2M) {
        message.error('图像必须小于2MB！');
        reject(file);
      } else {
        resolve(file);
      }
    });
  },

  /**
   * 表格信息
   * @param loding
   * @returns {{filterTitle: string, filterConfirm: string, filterReset: string, emptyText: string}}
   */
  tbLocale(loading) {
    return {
      filterTitle: '筛选',
      filterConfirm: '确定',
      filterReset: '重置',
      emptyText: loading ? '正在加载中...' : '暂无相关信息',
    };
  },

  /**
   * 生成数组
   * @param len
   * @param start
   * @returns {Array}
   */
  generateArray(len, start = 0) {
    const arr = [];
    for (let i = start; i < len; i++) {
      arr.push(i);
    }
    return arr;
  },

  /**
   * 程序暂停
   * @param ms
   * @returns {Promise<any>}
   */
  sleep(ms = 1000) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  },

  /**
   * 对象数组添加
   * @param orgArr 原数组
   * @param tarArr 添加目标
   * @param predicate(obj) 条件
   */
  objectArrayAdd(orgArr, tarArr, predicate) {
    if (orgArr instanceof Array === false) {
      return [];
    } else if (tarArr instanceof Array === false || typeof predicate !== 'function') {
      return orgArr;
    }
    try {
      const [...arr] = orgArr;
      for (let i = 0; i < tarArr.length; i++) {
        const obj = predicate(tarArr[i]);
        if (obj && tarArr instanceof Object) {
          arr.push(obj);
        }
      }
      return arr;
    } catch (e) {
      console.error(e);
      return [];
    }
  },

  /**
   * 设置值
   * @param self
   * @param data
   * @param cb
   */
  setState(self, data, cb) {
    if (self._isMounted) {
      self.setState(data, () => {
        if (cb) cb();
      });
    }
  },

  /**
   * 设置值同步
   * @param self
   * @param data
   * @param cb
   */
  setStateSync(self, data) {
    return new Promise(resolve => {
      if (self._isMounted) {
        self.setState(data, () => {
          resolve();
        });
      } else {
        resolve();
      }
    });
  },

  /**
   * 设置用户登录信息
   * @param data
   */
  setLoginInfo(data) {
    app.setData('rights', data.rights);
    app.setData('rights_duizhang', data.teamposition_id);
    app.setData('bsrno', data.bsrno);
    app.setData('hasmallrole', data.hasmallrole);
    app.setData('team', data.team);
    app.setData('multeamright', data.multeamright);
    app.setData('vname', data.vname);
    app.setData('team_id', data.team_id);
    app.setData('teampositionname', data.teampositionname);
    app.setData('teamname', data.teamname);
    app.setData('idno', data.idno);
    app.setData('nickname', data.nickname);
    app.setData('passport', data.passport);
    app.setData('bloodtype', data.bloodtype);
    app.setData('drughis', data.drughis);
    app.setData('emecontact', data.emecontact);
    app.setData('emecontactphone', data.emecontactphone);
    app.setData('message_audit', data.message_audit);
    app.setData('nationwide_rights', data.nationwide_rights);
  },

  /**
   * 下载文件
   * @param url
   * @returns {boolean}
   */
  downFile(url) {
    try {
      let iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      return true;
    } catch (e) {
      app.alert('下载失败', 'error');
      return false;
    }
  },

  /**
   * 下载文件(POST格式)
   * @param url
   * @returns {boolean}
   */
  downPostFile(url, data) {
    try {
      const form = document.createElement('form');
      form.method = 'post';
      form.style.display = 'none';
      form.action = config.serverUrl + url;
      form.target = '';
      let child = '';
      for (let k in data) {
        child += `<input type="hidden" name="${k}" value="${data[k]}"/>`;
      }
      form.innerHTML = child;
      document.body.appendChild(form);
      form.submit();
      return true;
    } catch (e) {
      app.alert('下载失败', 'error');
      return false;
    }
  },

  /**
   * 设置白名单权限
   * @returns {Promise<void>}
   */
  async setWhiteRights() {
    if (app.getToken()) {
      const params = {
        indexno: app.getData('indexno'),
        account: app.getData('account'),
      };
      const { flag, data, msg } = await app.post(api.AuditRights, params);
      if (flag === 1) {
        app.setData('news_audit', data.news_audit);
        app.setData('message_audit', data.message_audit);
        app.setData('train_audit', data.train_audit);
        app.setData('rights', data.rights);
        app.setData('rights_duizhang', data.teamposition_id);
        console.log(data)
      } else {
        app.removeData('news_audit');
        app.removeData('message_audit');
        app.removeData('train_audit');
        app.alert(msg, 'error');
      }
    }
  },

  /**
   * 获取服务器时间
   * @returns {Promise<Date>}
   */
  async getServerTime() {
    let { flag, data } = await this.post(api.ServerTime);
    if (flag === 1) {
      return new Date(parseInt(data.timestamp));
    }
    return new Date();
  },

  /**
   * 整数值
   * @returns {string}
   * @constructor
   */
  IntegerFormat(num = 0) {
    var reg = /\d{1,3}(?=(\d{3})+$)/g;
    return (num + '').replace(reg, '$&,');
  },

  /**
   * 返回页面
   * @param self
   */
  backPage(self) {
    self.props.history.go(-1);
  },

  /**
   * 转换参数
   * @param url
   */
  parseQueryString(url) {
    let obj = {};
    let keyvalue = [];
    let key = '',
      value = '';
    let paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
    for (let i in paraString) {
      keyvalue = paraString[i].split('=');
      key = keyvalue[0];
      value = keyvalue[1];
      obj[key] = value;
    }
    return obj;
  },

  /**
   * get请求URL组装
   * @param url
   * @param params
   * @returns {string}
   */
  urlGet(url, params = {}) {
    let pramaStr = Object.keys(params).map(p => p + '=' + params[p]).join('&');
    return config.serverUrl + url + '?' + pramaStr;
  },

  /**
   * 获取请求参数 indexno和account
   * @returns {{indexno: *, account: *}}
   */
  getReqParams() {
    return {
      indexno: app.getData('indexno'),
      account: app.getData('account'),
    };
  }
};

export { app, api, config };



// WEBPACK FOOTER //
// ./src/app.jsx